<template>
  <div class="familytree"
       :class="{unborn: !person.born && person.parents.length}">
    <div v-if="person.parents.length"
         class='subtrees'>
      <familytree v-for="parent in person.parents"
                :class="'familytree--' + thisAncestors"
                :person="parent"
                :ancestors="thisAncestors"
                v-on:waaa="bubble('waaa')"></familytree>
    </div>
    <span class='ball-lines' v-html="ballLines"></span>
    <button v-if="ancestors > 0"
            :class="{ready: parentsBorn, born: person.born}"
            :disabled="!(parentsBorn) || person.born"
            @click="waaa()" ></button>
    <span>{{ person.name }}</span>
    <ul class='chromosomes'>
      <li class='chromosome'
          v-for="chromosome in person.genome">
        <ul class='genes'>
          <li class='gene'
            v-for="gene in chromosome"
            :data-inherit="gene.inheritedByChild.toString()"
            :class="'gene--' + slugify(gene.origin)">
              <span>{{gene.gene}}</span>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>


  export default { 
    props: [ 'person', 'ancestors' ],
    name: 'familytree',
    mounted: function() {
      this.$forceUpdate();
    },
    updated: function() {
      this.setBallLines();
    },
    data: function () {
      return {
        ballLines: ''
      }
    },
    computed: {
      parentsBorn: function(){
        return this.person.parents[0].born && this.person.parents[1].born;
      },
      thisAncestors: function(){
        return this.ancestors - 1;
      }
    },
    methods: {
      slugify: function(text) {
        return text
          .toLowerCase()
          .replace(/[^\w ]+/g,'')
          .replace(/ +/g,'-')
      },
      waaa: function() {
        this.person.born = true;
        this.$emit('waaa');
      },
      bubble: function(event) {
        this.$emit(event); 
      },
      setBallLines: function() {

        var vm = this;

        vm.$nextTick(function(){

          var containerwidth = [...[].slice.call(document.getElementsByClassName('familytree--' + this.ancestors))][0].offsetWidth;

          var radius = 100;
          var padding = 30;

          var vwidth = containerwidth + 2*padding;
          var vheight = 2.2 * radius + padding;
          var linewidth = (containerwidth - 4 * radius) / 2;

          var animationlength = (2 * 1.6 * radius) + linewidth;

          vm.ballLines = `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve"
  viewBox="0 0 ${vwidth} ${vheight}">
      <g class='group'>
      <path class='line' d="M30,30 a${radius},${radius} 0 0,0 ${radius},${radius} h${linewidth} a${radius},${radius} 0 0,1 ${radius},${radius}" />
      <path class='balls balls--${this.thisAncestors}' data-length="${animationlength}" d="M30,30 a${radius},${radius} 0 0,0 ${radius},${radius} h${linewidth} a${radius},${radius} 0 0,1 ${radius},${radius}" />
      </g>
      <g class='group'>
      <path transform="translate(${vwidth}) scale(-1, 1)" class='line line--right' d="M30,30 a${radius},${radius} 0 0,0 ${radius},${radius} h${linewidth} a${radius},${radius} 0 0,1 ${radius},${radius}" />
      <path transform="translate(${vwidth}) scale(-1, 1)" class='balls balls--${this.thisAncestors} data-length="${animationlength}" balls--right' d="M30,30 a${radius},${radius} 0 0,0 ${radius},${radius} h${linewidth} a${radius},${radius} 0 0,1 ${radius},${radius}" />
      </g>
    </svg>`

      return true;
    })
    }
  }
}
</script>

<style lang="scss">

  @import '../stylesheets/_zeplin';

  $maxZoom: 4;

  $geneSize: 2rem * $maxZoom;
  $genePadding: 0.2 * $geneSize;
  $genesPerChromosome: 4;
  $connectorLineWidth: 1px * $maxZoom;

  .familytree {
    position: relative;
    text-align: center;

    &--3 {
      width: 100% * $maxZoom;
      padding-top: 3rem * $maxZoom;
      & > .chromosomes > .chromosome > .genes > .gene {
        opacity: 1 !important;
      }
      transform-origin: top left;
      transition: 1s ease all;
    }

    display: flex;
    flex-direction: column;
    flex-grow: 1;

    .subtrees {
      display: flex;
      flex-direction: row;
      width: 100%;
    }

    & > span {
      display: block;
      font-size: 1rem * $maxZoom;
      // word-spacing: 100rem * $maxZoom; // This forces a break on every word
      text-transform: uppercase;
      text-align: center;
      margin: 0 auto;
      color: $ui-02;
    }

    button {
      $size: $geneSize * 1.8;
      border-radius: 100%;
      height: $size;
      width: $size;
      margin-bottom: $size / 5;
      display: flex;
      align-items: center;
      align-self: center;

      $buttonIconSize: $size/3;
      $roothalf: 0.70710678119;

      &.ready:before,
      &.ready:after, {
        content: '';
        display: block;
        position: absolute;
        width: $buttonIconSize;
        height: 2px * $maxZoom;
        background: black;
        transition: all 0.4s ease;
        transition-property: height, width, transform;
      }
      &.ready:before {
      }
      &.ready:after {
        transform: rotate(90deg);
      }
      &.ready.born:before {
        width: $buttonIconSize / 2;
        transform-origin: left center;
        transform: translateX(-0.25 * $roothalf * $buttonIconSize) translateY(0) rotate(45deg);
      }
      &.ready.born:after {
        transform: translateX(0.25 * $roothalf * $buttonIconSize) translateY(0) rotate(135deg);
      }

      &:not(.ready) {
        background: transparent;
        border: 1px * $maxZoom dotted white;
        opacity: 0.5;
        span {
          opacity: 0;
        }
      }

    }

    // Unborn defaults

    &.unborn {

      & > .subtrees > .familytree:not(.unborn) > .chromosomes > .chromosome > .genes > .gene {
        opacity: 1 !important;
      }

      & > .chromosomes {

        opacity: 0.5;

        .chromosome {
          & > .genes {
            background: transparent;
            border: 1px * $maxZoom solid white;

            li.gene {

              background-color: transparent;
              border: 1px * $maxZoom solid white;
              opacity: 1;

              & > span {
                opacity: 0;
              }

            }
          }
        }
      }
    }

    // Transitions

    .chromosomes * {
      transition: all 0.4s ease;
    }
    &.unborn > .subtrees > .familytree:not(.unborn) > .chromosomes *,
    .familytree--3:not(.unborn) > .chromosomes * {
      transition-delay: 2.5s;
    }

  }

    // Chromosomes and genes

  .chromosomes,
  .genes,
  .gene {
    list-style: none;
    padding: 0;
    border: 1px * $maxZoom solid transparent;
  }

  .chromosomes {

    margin-bottom: $geneSize * -1;
    padding-bottom: $geneSize/2;

    display: flex;
    position: relative;
    flex-direction: row;
    justify-content: center;

    .chromosome {

      display: flex;

      & > .genes {

        display: flex;
        flex-direction: column;

        @supports (-ms-ime-align:auto) {
          justify-content: space-around; 
        }
        justify-content: space-evenly;

        margin: 4px * $maxZoom;
        background: white;
        text-align: center;

        height: ($geneSize * $genesPerChromosome) + ($genePadding * ($genesPerChromosome + 1));
        width:  $geneSize + ($genePadding * 2);
        border-radius: $genePadding + $geneSize/2;

        li.gene {

          display: flex;
          align-items: center;
          align-self: center;
          justify-content: center;

          width: $geneSize;
          height: $geneSize;
          border-radius: $geneSize / 2;

          & > span {
            font-size: 10px * $maxZoom;
            line-height: 1;
            color: white;
          }

          &--france, { background-color: $french; }
          &--germany { background-color: $german; }
          &--scandinavia { background-color: $scandinavian; }
          &--northeast-europe { background-color: $belgian; }
          &--scotland-ireland { background-color: $irish; }
          &--north-africa { background-color: $african; }
          &--china { background-color: $chinese; }
          &--india { background-color: $dutch; }
          &--england-wales { background-color: $british; }
          &--iberia { background-color: $spanish; }

          &[data-inherit=false] {
            opacity: 0.3;
          }
        }
      }
    }
  }

  .ball-lines {

    .familytree--0 & {
      display: none;
    }

    display: block;
    position: relative;
    width: 50%;
    path {
      fill: none;
      stroke: white;
      stroke-linecap: round;
      &.line {
        stroke-width: 10;
        .familytree.unborn > & {
          stroke: rgba(white, 0.3);
          stroke-dasharray: 20 20;
        }

        body.br-chrome:not(.br-ie) &--right {
          transform-origin: top right;
          transform: translateX(0%) scaleX(-1);
        }
        body.win10.br-chrome:not(.br-ie) &--right,
        body.win7.br-chrome:not(.br-ie) &--right, {
          transform-origin: top right;
          transform: translateX(-100%) scaleX(-1);
        }

      }

      $balls: 8;
      $jiggle: 100;

      $width-1: 1350;
      $width-2: 2100;
      $width-3: 3500;

      &.balls {
        body.br-chrome:not(.br-ie) &--right {
          transform-origin: top right;
          transform: translateX(0%) scaleX(-1);
        }
        body.win10.br-chrome:not(.br-ie) &--right,
        body.win7.br-chrome:not(.br-ie) &--right, {
          transform-origin: top right;
          transform: translateX(-100%) scaleX(-1);
        }

        
        stroke-width: 60;

        @mixin ball-stroke($width, $balls, $jiggle) {

          $spacing: $width/$balls;

          stroke-dasharray: 1 $spacing - random($jiggle) 1 $spacing -
          random($jiggle) 1 $spacing - random($jiggle) 1 $spacing -
          random($jiggle) 1 $spacing - random($jiggle) 1 $spacing -
          random($jiggle) 1 $spacing - random($jiggle) 1 $spacing -
          random($jiggle) 1 $width;
        }

        &--0 {
          @include ball-stroke($width-1, $balls, $jiggle);
          animation-name: balldrop-1;
          stroke-dashoffset: $width-1;
        }

        &--1 {
          @include ball-stroke($width-2, $balls, $jiggle);
          animation-name: balldrop-2;
          stroke-dashoffset: $width-2;
        }

        &--2 {
          @include ball-stroke($width-3, $balls, $jiggle);
          animation-name: balldrop-3;
          stroke-dashoffset: $width-3;
        }

        animation: balldrop 3s cubic-bezier(0.550, 0.055, 0.675, 0.190) 0s 1 forwards;

      }

      @keyframes balldrop-1 {
        from { stroke-dashoffset: $width-1 }
        to { stroke-dashoffset: -1 * $width-1 }
      }
      @keyframes balldrop-2 {
        from { stroke-dashoffset: $width-2 }
        to { stroke-dashoffset: -1 * $width-2 }
      }
      @keyframes balldrop-3 {
        from { stroke-dashoffset: $width-3 }
        to { stroke-dashoffset: -1 * $width-3 }
      }

      animation-play-state: running;

      .familytree.unborn > & {
        animation-play-state: paused;
      }

    }
  }


</style>


// WEBPACK FOOTER //
// src/assets/components/familytree.vue